module.exports = __webpack_public_path__ + "img/logo.2391a31e.png";